import React from 'react'
import Modal from 'react-modal'
import TipContentText from './TipContentText'
import TipContentImage from './TipContentImage'
import TipContentVideo from './TipContentVideo'
import SVGIcon from '../helpers/icons'

function Tip (props) {

  const [modalIsOpen, setIsOpen] = React.useState(false)
  const openModal = function () {
    setIsOpen(true)
  }
  const closeModal = function () {
    setIsOpen(false)
  }

  const content = function (settings) {
    if (settings.type === 'text') {
      return <TipContentText settings={settings.text_modal} closemodal={closeModal}/>
    }
    if (settings.type === 'image') {
      return <TipContentImage settings={settings.image_modal} closemodal={closeModal}/>
    }
    if (settings.type === 'video') {
      return <TipContentVideo settings={settings.video_modal} closemodal={closeModal}/>
    }
    return null
  }

  return (
    <React.Fragment>
      <button className={'tooltip'} onClick={openModal}><SVGIcon type={'info'} fill={'#B2B2B2'}/></button>
      <Modal
        isOpen={modalIsOpen}
        shouldCloseOnOverlayClick={true}
        onRequestClose={closeModal}
        className={'tip ' + props.settings.type}
      >
        {content(props.settings)}
      </Modal>
    </React.Fragment>
  )
}

export default Tip